import { useEffect } from 'react';
import { motion } from 'framer-motion';
import heroBg from '../assets/hero-bg.png';
import bg2 from '../assets/bg2.jpg';
import bg3 from '../assets/bg3.png';
import aboutMemeBg from '../assets/aboutmeme.png';
import tokenomicsBg from '../assets/tokenomics.png';
import joinUs from '../assets/joinus.png';
import buyNoBg from '../assets/buynobg.png';
import tgLogo from '../assets/tglogo2.png';
import xLogo from '../assets/x.png';
import roadmapBg from '../assets/roadmapnew.png';
import explainerBg from '../assets/explainerbg.png';
import howToBuyVideo from '../assets/howtobuyfinal.mp4';
import './Home.css';
import './Tokenomics.css';
import './Roadmap.css';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } },
};

const stagger = {
  show: { transition: { staggerChildren: 0.15 } },
};

const tokStats = [
  { label: 'Total Supply',  value: '999,999,999', glow: 'cyan' },
  { label: 'Chain',         value: 'Ethereum',    glow: 'cyan' },
  { label: 'Ticker',        value: '$CULT',        glow: 'red'  },
  { label: 'Team Tokens',   value: '0%',           glow: 'red'  },
  { label: 'To Liquidity',  value: '100%',         glow: 'cyan' },
  { label: 'LP',            value: 'Locked',       glow: 'cyan' },
  { label: 'Buy Tax',       value: '0%',           glow: 'red'  },
  { label: 'Sell Tax',      value: '0%',           glow: 'red'  },
  { label: 'Ownership',     value: 'Renounced',    glow: 'cyan' },
  { label: 'Contract',      value: 'Verified',     glow: 'cyan' },
];

const phases = [
  {
    phase: 'Phase 1',
    title: 'Genesis',
    status: 'active',
    items: [
      'Website launch',
      'Smart contract deployment',
      'Initial liquidity on Uniswap',
      'Community building - Telegram & Twitter',
      'First commissioned artwork reveal',
    ],
  },
  {
    phase: 'Phase 2',
    title: 'Culture Spreads',
    status: 'upcoming',
    items: [
      'CoinGecko & CoinMarketCap listings',
      'Meme Index gallery launch',
      'Artist collaborations revealed',
      'Community events & meme contests',
      '1,000+ holders',
    ],
  },
  {
    phase: 'Phase 3',
    title: 'Mainstream',
    status: 'upcoming',
    items: [
      'CEX listings',
      'Merch drop',
      'DAO governance for index additions',
      'Cross-chain expansion',
      '10,000+ holders',
    ],
  },
  {
    phase: 'Phase 4',
    title: 'The CULT Is Real',
    status: 'upcoming',
    items: [
      'TBA',
      'TBA',
      'TBA',
    ],
  },
];

function NeonDivider() {
  return (
    <motion.div
      className="neon-divider"
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    />
  );
}

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
    }
  }, []);

  return (
    <main className="page">

      {/* Hero */}
      <section id="home" className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-fade-bottom" />
        <div className="hero-neon">
          <span className="neon-meme">MEME</span>
          <span className="neon-culture">
            <span className="neon-cult">CULT</span>URE
          </span>
        </div>
        <div className="neon-arrow">
          <div className="neon-arrow-line" />
          <div className="neon-arrow-head" />
        </div>
      </section>

      <NeonDivider />

      {/* Meme Index */}
      <section id="meme-index" className="section meme-index-section" style={{ backgroundImage: `url(${bg2})` }}>
        <div className="section-fade-top" />
        <div className="section-fade-bottom" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="section-title">
              THE <span className="accent">OFFICIAL</span> UNOFFICIAL <span className="accent">MEME</span> INDEX
            </h2>
            <p className="section-sub muted">
              $CULT represents the culture which we live for- it pays homage to every meme, every chain, and every idea that was.
            </p>
          </motion.div>
        </div>
      </section>

      <NeonDivider />

      {/* About */}
      <section id="about" className="section about-section" style={{ backgroundImage: `url(${aboutMemeBg})` }}>
        <div className="section-fade-top" />
        <div className="section-fade-bottom" />
        <div className="container about-content">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="about-header"
          >
            <h2 className="section-title">
              WHAT IS <span className="accent">MEME CULTURE</span>?
            </h2>
          </motion.div>
          <div className="about-body">
            {[
              'Meme Culture ($CULT) is a token built around a simple idea: memes are culture. Every major meme coin that has ever exploded- Doge, Shiba, Pepe, Bonk, and countless others represents a movement in internet history. $CULT is the generalization of all of them.',
              'Instead of picking winners, $CULT embraces the entire meme ecosystem. It is a cultural index, a community movement, and a celebration of what makes memes unique- the power of a shared joke to move billions of dollars.',
              'No team allocation. No VC money. No roadmap full of promises. Just culture, community, and the memes that got us here.',
            ].map((text, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ delay: i * 0.15, duration: 0.6 }}
                className="about-para"
              >
                {text}
              </motion.p>
            ))}
          </div>
        </div>
      </section>

      <NeonDivider />

      {/* Why CULT */}
      <section id="why" className="section why-section" style={{ backgroundImage: `url(${bg3})` }}>
        <div className="section-fade-top" />
        <div className="section-fade-bottom" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            WHY <span className="accent2">$CULT</span>
          </motion.h2>
          <div className="why-grid">
            {[
              { title: 'Cultural Index', body: 'Instead of betting on one meme, $CULT represents the entire meme ecosystem, diversified culture.' },
              { title: 'Community Driven', body: 'The holders decide what gets added, what gets celebrated, and where the culture goes next.' },
              { title: 'Artist Backed', body: 'Original art commissioned from real artists. No lazy copy-paste tokens here.' },
              { title: 'Built on Ethereum', body: 'The most battle-tested chain. Decentralized, trustless, and permanent.' },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                className="card why-card"
                initial={{ opacity: 0, x: i % 2 === 0 ? -40 : 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: i * 0.1, duration: 0.6, ease: 'easeOut' }}
              >
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <NeonDivider />

      {/* Tokenomics */}
      <section id="tokenomics" className="section tok-section" style={{ backgroundImage: `url(${tokenomicsBg})` }}>
        <div className="tok-overlay" />
        <div className="container tok-content">
          <motion.div
            className="tok-header"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="tok-title">
              TOKEN<span className="tok-accent">OMICS</span>
            </h2>
            <p className="tok-sub">Simple. Fair. Community first.</p>
          </motion.div>
          <div className="tok-grid">
            {tokStats.map(({ label, value, glow }, i) => (
              <motion.div
                key={label}
                className={`tok-card tok-card--${glow}`}
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ delay: i * 0.07, duration: 0.5, ease: 'easeOut' }}
                whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
              >
                <div className="tok-card-value">{value}</div>
                <div className="tok-card-label">{label}</div>
              </motion.div>
            ))}
          </div>

          <motion.div
            className="tok-ca"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
          >
            <span className="tok-ca-label">CA</span>
            <a
              className="tok-ca-address"
              href="https://etherscan.io/token/0xaab77ed699f42ebc44edcf37d115c2a70414da2c"
              target="_blank"
              rel="noopener noreferrer"
            >
              0xaab77ed699f42ebc44edcf37d115c2a70414da2c
            </a>
          </motion.div>

</div>
      </section>

      <NeonDivider />

      {/* How To Buy */}
      <section id="how-to-buy" className="section how-to-buy-section" style={{ backgroundImage: `url(${explainerBg})` }}>
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            HOW TO <span className="accent">BUY</span>
          </motion.h2>
          <motion.div
            className="htb-video-wrap"
            initial={{ opacity: 0, scale: 0.93, y: 30 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            <video className="htb-video" controls playsInline preload="metadata">
              <source src={howToBuyVideo} type="video/mp4" />
            </video>
          </motion.div>
        </div>
      </section>

      <NeonDivider />

      {/* Roadmap */}
      <section id="roadmap" className="section roadmap-home-section" style={{ backgroundImage: `url(${roadmapBg})` }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="section-title">
              THE <span className="accent">PLAN</span>
            </h2>
            <p className="section-sub muted">Where we're going. Subject to community input and vibes.</p>
          </motion.div>

          <div className="roadmap-timeline">
            {phases.map((phase, i) => (
              <motion.div
                key={phase.phase}
                className={`roadmap-item ${phase.status}`}
                initial={{ opacity: 0, x: i % 2 === 0 ? -40 : 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
              >
                <div className="roadmap-marker">
                  <div className="marker-dot" />
                  {i < phases.length - 1 && <div className="marker-line" />}
                </div>
                <div className="card roadmap-card">
                  <div className="roadmap-header">
                    <span className="phase-label">{phase.phase}</span>
                    {phase.status === 'active' && <span className="status-badge">Active</span>}
                  </div>
                  <h3>{phase.title}</h3>
                  <ul>
                    {phase.items.map((item) => (
                      <li key={item}>
                        <span className="check">✓</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <NeonDivider />

      {/* Join The Cult */}
      <section id="join" className="section join-section" style={{ backgroundImage: `url(${joinUs})` }}>
        <div className="join-overlay" />
        <div className="container join-content">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
          >
            JOIN THE <span className="accent">CULT</span>
          </motion.h2>
          <motion.div
            className="join-logo-grid"
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
          >
            <motion.a variants={fadeUp} href="https://app.uniswap.org/swap?outputCurrency=0xaab77ed699f42ebc44edcf37d115c2a70414da2c" target="_blank" rel="noopener noreferrer" className="join-logo-link">
              <img src={buyNoBg} alt="Buy $CULT on Uniswap" />
              <span>Buy $CULT</span>
            </motion.a>
            <motion.a variants={fadeUp} href="https://t.me/memecultureeth" target="_blank" rel="noopener noreferrer" className="join-logo-link">
              <img src={tgLogo} alt="Telegram" />
              <span>Telegram</span>
            </motion.a>
            <motion.a variants={fadeUp} href="https://x.com/MemeCultureETH" target="_blank" rel="noopener noreferrer" className="join-logo-link">
              <img src={xLogo} alt="Twitter / X" />
              <span>Twitter / X</span>
            </motion.a>
          </motion.div>
        </div>
      </section>

    </main>
  );
}
